export const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

export const filterByKeys = (data, fields, applyFn) => Object.keys(data)
    .filter((key) => fields.includes(key))
    .reduce((obj, key) => ({ ...obj, [key]: typeof applyFn === 'function' ? applyFn(data[key]) : data[key] }), {});
